import { defineTour } from '@lopettia/simul';

/**
 * Finance — revenue summary, commission tiers, payouts. Mirrors
 * docs/manuals/06-finance.md.
 */
export const financeTour = defineTour({
  name: 'Finance close cycle',
  description:
    'Revenue summary, commission tier configuration, and the payout queue.',
  steps: [
    {
      id: 'fn-revenue',
      kind: 'info',
      target: '[data-tour-id="nav-analytics"]',
      prelude: { goto: '/analytics' },
      message:
        '**Revenue summary** — bookings, billings, and net new ARR rolled '
        + 'into a single timeline.',
      advanceOn: 'manual',
      spotlight: true,
    },
    {
      id: 'fn-tiers',
      kind: 'navigate',
      target: '[data-tour-id="nav-commission-tiers"]',
      toUrl: '/admin/commission-tiers',
      message:
        '**Commission tiers** define the rate cards that drive payouts.',
      advanceOn: 'navigate',
    },
    {
      id: 'fn-payouts',
      kind: 'navigate',
      target: '[data-tour-id="nav-commissions"]',
      toUrl: '/admin/commissions',
      message:
        'The **commissions** queue is where you review, approve, and export '
        + 'each pay period.',
      advanceOn: 'navigate',
    },
  ],
});

export default financeTour;
